/* global axios */
import ApiClient from './ApiClient';

class LeadTaskTypesAPI extends ApiClient {
  constructor() {
    super('lead_task_types', { accountScoped: true });
  }

  reorder(positions) {
    return axios.post(`${this.url}/reorder`, { positions });
  }
}

export default new LeadTaskTypesAPI();
